import debounce from 'lodash/debounce';
import { useEffect, useRef } from 'react';
import { useConstant } from './useConstant';
const normalizeOpts = (opts) => ({
    leading: false,
    trailing: true,
    ...opts,
});
/**
 * Immutable wrapped `debounce` hook.
 * NOTE: This refines type for lodash/debounce to use correct return type if
 *  { leading: true } (Default: false)
 * @see debounce
 */
export const useDebounce = (fn, wait, opts) => {
    const fnRef = useRef(fn);
    fnRef.current = fn;
    const debounced = useConstant(() => debounce((...args) => fnRef.current(...args), wait, normalizeOpts(opts)));
    useEffect(() => () => {
        // Don't fire debounced function when unmounted
        debounced.cancel();
    }, []);
    // NOTE: Casting as `any` b/c I don't want to deal w/ implementing the entire
    //  debounce signature just to tell TypeScript that what we're returning is
    //  the same.
    return useRef(debounced).current;
};
// Testing iOS scroll, this value works best for firing debounce efficiently
// when the URL bar hides.
export const IOS_DEBOUNCE_SCROLL = 85;
//# sourceMappingURL=useDebounce.js.map